//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoRangeSliderBasic from './demos/DemoRangeSliderBasic.vue'
import DemoRangeSliderStates from './demos/DemoRangeSliderStates.vue'
import DemoRangeSliderColor from './demos/DemoRangeSliderColor.vue'
import DemoRangeSliderMinAndMax from './demos/DemoRangeSliderMinAndMax.vue'
import DemoRangeSliderStep from './demos/DemoRangeSliderStep.vue'
import DemoRangeSliderVertical from './demos/DemoRangeSliderVertical.vue'
import DemoRangeSliderThumbLabel from './demos/DemoRangeSliderThumbLabel.vue'

// code
import {
  rangeSliderBasic,
  rangeSliderStates,
  rangeSliderColor,
  rangeSliderMinAndMax,
  rangeSliderStep,
  rangeSliderVertical,
  rangeSliderThumbLabel,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoRangeSliderBasic,
    DemoRangeSliderStates,
    DemoRangeSliderColor,
    DemoRangeSliderMinAndMax,
    DemoRangeSliderStep,
    DemoRangeSliderVertical,
    DemoRangeSliderThumbLabel,
  },
  setup() {
    return {
      codeSnippets: {
        rangeSliderBasic,
        rangeSliderStates,
        rangeSliderColor,
        rangeSliderMinAndMax,
        rangeSliderStep,
        rangeSliderVertical,
        rangeSliderThumbLabel,
      },
    }
  },
}
